<template>
    <div class="table-page" v-if="loaded">
        <my-table :name="pageKey" :cols="cols" :data="list" :loading="loading" :page-param="page"
                  :batch="batch" :operate="operate"
                  @sort="sort"
                  @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" @cndClusterChange="cndClusterChange">
<!--            <template #right>-->
<!--                <el-button class="btn-blue" plain icon="el-icon-plus" @click="add" :disabled="'M_SM_PF_I'|auth">添加</el-button>-->
<!--            </template>-->
        </my-table>

        <common-add ref="add" :dialog="editDialog" :cols="cols" @save="editSave" @delEdit="delEdit"></common-add>
        <common-detail :dialog="detailDialog" :cols="cols" @save="editSave"></common-detail>
    </div>
</template>

<script>
    import myMixin from '@/util/myMixin';
    import tableMixin from '@/util/tableMixin';


    export default {
        mixins: [tableMixin, myMixin],
        data() {
            return {
                pageKey: 'profile',
                loaded: true,
                api: {
                    list: 'sys/profile/findProfilePage',   // 列表接口
                    detail: 'sys/profile/findProfileByPk', // 详情接口
                    add: 'sys/profile/insertProfile',      // 新增接口
                    update: 'sys/profile/updateProfile',   // 修改接口
                    del: 'sys/profile/deleteProfile',      // 删除接口
                },

                operate: [
                    {txt: '修改', auth: 'M_SM_PF_E', type: 'primary', icon: 'el-icon-edit', event: this.update, whether: this.updateWhether},
                    {txt: '详情', auth: '', type: 'success', icon: 'el-icon-view', event: this.detail},
                ],

                // 批量操作的参数
                batch: [
                ],
                cols: [
                    {
                        key: "id",
                        value: "主键ID",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: false,
                        viewAdd: false,
                        viewEdit: false,
                        viewDetail: false,
                        width: 200,
                    },
                    {
                        key: "parameterCode",
                        value: "编码",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail: true,
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "parameterDescribe",
                        value: "描述",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: false,
                        viewDetail: true,
                        minWidth: 200
                    },
                    {
                        key: "valueType",
                        value: "值类型",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: false,
                        viewDetail: true,
                        minWidth: 200,
                        type: this.$variable.colType.SELECT,
                        param: {
                            dict : '000007'
                        }
                    },
                    {
                        key: "fieldType",
                        value: "字段类型",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: false,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail: false,
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                        type: this.$variable.colType.SELECT,
                        param: {
                            dict : '000008'
                        }

                    },
                    {
                        key: "value",
                        value: "单值",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail: true,
                        width: 200,
                    },
                    {
                        key: "valueBeg",
                        value: "双值开始",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail: true,
                        minWidth: 200
                    },
                    {
                        key: "valueEnd",
                        value: "双值结束",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail: true,
                        minWidth: 200,
                    },
                    {
                        key: "allowEdit",
                        value: "是否可编辑",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: false,
                        viewDetail: true,
                        minWidth: 200,
                        type: this.$variable.colType.SELECT,
                        param: {
                            dict : '000004'
                        }
                    },
                    {
                        key: "remark",
                        value: "备注",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: true,
                        viewEdit: true,
                        viewDetail: true,
                        minWidth: 200,
                    },
                ],
            }
        },
        methods: {
            updateWhether(item){
                // false表示显示，true表示置灰  0标识不能编辑就是置灰
                return item.allowEdit === 0;
            }
        },
        created() {
            // 枚举类型查询
            let dataCode = [];
            for (let i = 0; i < this.cols.length; i++) {
                if (this.cols[i].param && this.cols[i].param.dict) {
                    dataCode.push(this.cols[i].param.dict);
                }
            }
            if (dataCode.length !== 0) {
                this.$api.post('sys/dict/selectDictItemMap', dataCode)
                    .then(res => {
                        for (let i = 0; i < this.cols.length; i++) {
                            if (this.cols[i].param && this.cols[i].param.dict) {
                                let keyValue = {};
                                if(res[this.cols[i].param.dict]){
                                    for (let j = 0; j< res[this.cols[i].param.dict].length; j++){
                                        keyValue[res[this.cols[i].param.dict][j].itemDataCode] = res[this.cols[i].param.dict][j].itemDataName;
                                    }
                                    this.cols[i].param.keyValue = keyValue;
                                }
                            }
                        }
                        this.loaded = false;
                        this.$nextTick(() => {this.loaded = true});
                    });
            }
        },
    }
</script>
